<script>
  import { createEventDispatcher } from "svelte";
  import { factoryStore } from "../store/factories.js";
  import { inputVariableStore } from "../store/inputVariables.js";
  import InputPercent from "./InputPercent.svelte";
  import InputMoney from "./InputMoney.svelte";
  import { outputVariableStore } from "../store/outputVariables.js";
  import { numberFormatStore } from "../store/numberFormat.js";
  const dispatch = createEventDispatcher();
  export let variable;
  export let readonly = false;
  export let subSection;
  import { getContext } from "svelte";
  import { langTextStore } from "../store/langtexts.js";
  const { snackbar } = getContext("app");

  let timer;
  function bubbleDebounced(type) {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      bubble(type);
    }, 50);
  }
  var minText = $langTextStore.getText("general-min-value");
  var maxText = $langTextStore.getText("general-max-value");
  function checkAndBubble() {
    //beware of duplicated function
    window.setTimeout(() => {
      var theRealVar = $factoryStore.currentCalculator.variables.find(
        (v) => v.varNameKey == variable.nameKey
      );
      var actual = $inputVariableStore[variable.nameKey];
      var min = theRealVar.minValue;
      var isToBig = min && min > actual;
      if (isToBig) {
        $inputVariableStore[variable.nameKey] = theRealVar.minValue;
        snackbar(
          "error",
          $langTextStore.getText("general-min-value") +
            ":" +
            theRealVar.minValue
        );
      }
      var max = theRealVar.maxValue;
      var isToBig = max && max < actual;
      if (isToBig) {
        $inputVariableStore[variable.nameKey] = theRealVar.maxValue;
        snackbar(
          "error",
          $langTextStore.getText("general-max-value") +
            ":" +
            theRealVar.maxValue
        );
      }
      bubble("change");
    }, 50);
  }
  function bubble(type) {
    try {
      dispatch(type);
    } catch (s) {
      alert("error");
    }
  }
  function isEdit(variable) {
    var theRealVar = getRealVar(variable);
    if (!theRealVar) return true;
    if (theRealVar.isFunction || theRealVar.readOnly) return false;
    return true;
  }

  function getRealVar(variable) {
    return $factoryStore.currentCalculator.variables.find(
      (v) => v.varNameKey == variable.nameKey
    );
  }
</script>

{#if variable.dataType == "int" || variable.dataType == "double" || variable.dataType == null}
  {#if isEdit(variable)}
    <input
      type="number"
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      on:focus={(e) => {
        e.target.select();
      }}
      varname={variable.nameKey}
      id={"inputfield-input-" +
        subSection.subSectionNameKey +
        variable.nameKey +
        Math.random()}
      bind:value={$inputVariableStore[variable.nameKey]}
      readonly={readonly || !isEdit(variable)}
      min={getRealVar(variable).minValue}
      max={getRealVar(variable).maxValue}
    />
  {:else}
    <input
      type="text"
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      on:focus={(e) => {
        e.target.select();
      }}
      varname={variable.nameKey}
      id={"inputfield-input-readonly-" +
        subSection.subSectionNameKey +
        variable.nameKey +
        Math.random()}
      value={$numberFormatStore.formatNumber(
        $outputVariableStore[variable.nameKey],0
      )}
      readonly={readonly || !isEdit(variable)}
      class="readonly"
    />
  {/if}
{:else if variable.dataType == "percent"}
  {#if isEdit(variable)}
    <InputPercent
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      id={"inputfield-input-" + subSection.subSectionNameKey + variable.nameKey}
      bind:value={$inputVariableStore[variable.nameKey]}
      readonly={readonly || !isEdit(variable)}
    />
  {:else}
    <InputPercent
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      id={"inputfield-input-" + subSection.subSectionNameKey + variable.nameKey}
      value={$outputVariableStore[variable.nameKey]}
      readonly={readonly || !isEdit(variable)}
    />
  {/if}
{:else if variable.dataType == "currency"}
  {#if isEdit(variable)}
    <InputMoney
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      mainCurrencyId={$factoryStore.currentCalculator.currencyId}
      alternateCurrencyId={$factoryStore.currentCalculator.alternateCurrencyId}
      alternateCurrencyRate={$inputVariableStore.alternateCurrencyRate}
      id={"inputfield-input-" +
        subSection.subSectionNameKey.replace(" ", "") +
        variable.nameKey.replace(" ", "")}
      bind:value={$inputVariableStore[variable.nameKey]}
      readonly={readonly || !isEdit(variable)}
    />
  {:else}
    <InputMoney
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      mainCurrencyId={$factoryStore.currentCalculator.currencyId}
      alternateCurrencyId={$factoryStore.currentCalculator.alternateCurrencyId}
      alternateCurrencyRate={$inputVariableStore.alternateCurrencyRate}
      id={"inputfield-input-" + subSection.subSectionNameKey + variable.nameKey}
      value={$outputVariableStore[variable.nameKey]}
      readonly={readonly || !isEdit(variable)}
    />
  {/if}
{:else if variable.dataType == "text"}
  {#if isEdit(variable)}
    <input
      type="text"
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      on:focus={(e) => {
        e.target.select();
      }}
      varname={variable.nameKey}
      id={"inputfield-input-" + subSection.subSectionNameKey + variable.nameKey}
      bind:value={$inputVariableStore[variable.nameKey]}
      readonly={readonly || !isEdit(variable)}
    />
  {:else}
    <input
      type="text"
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      on:focus={(e) => {
        e.target.select();
      }}
      varname={variable.nameKey}
      id={"inputfield-input-" + subSection.subSectionNameKey + variable.nameKey}
      value={$numberFormatStore.formatNumber(
        $outputVariableStore[variable.nameKey]
      )}
      readonly={readonly || !isEdit(variable)}
      class="readonly"
    />
  {/if}
{:else if variable.dataType == "date"}
  {#if isEdit(variable)}
    <input
      type="date"
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      on:focus={(e) => {
        e.target.select();
      }}
      varname={variable.nameKey}
      id={"inputfield-input-" + subSection.subSectionNameKey + variable.nameKey}
      bind:value={$inputVariableStore[variable.nameKey]}
      readonly={readonly || !isEdit(variable)}
    />
  {:else}
    <input
      type="text"
      on:keyup={() => {
        bubbleDebounced("keyup");
      }}
      on:change={() => {
        checkAndBubble();
      }}
      on:focusout={() => {
        bubble("focusout");
      }}
      on:focusin={() => {
        bubble("focusin");
      }}
      on:focus={(e) => {
        e.target.select();
      }}
      varname={variable.nameKey}
      id={"inputfield-input-" + subSection.subSectionNameKey + variable.nameKey}
      value={$numberFormatStore.formatNumber(
        $outputVariableStore[variable.nameKey]
      )}
      readonly={readonly || !isEdit(variable)}
    />
  {/if}
{:else}
  NOT USED YET! For Text fields
  <!-- <input
        type="text"
        on:keyup={bubbleDebounced("keyup")}
        on:change={bubbleDebounced("change")}
        on:focusout={bubble("focusout")}
        on:focusin={bubble("focusin")}
        varname={variable.nameKey}
        id={"inputfield-input-" +
            subSection.subSectionNameKey +
            variable.nameKey}
        bind:value={$inputVariableStore[variable.nameKey]}
        class:readonly={readonly || !isEdit(variable)}
        disabled={readonly || !isEdit(variable)}
    /> -->
{/if}
